import React, { useState, useRef } from "react";
import {
  FaWhatsapp,
  FaTwitter,
  FaLinkedin,
  FaInstagram,
  FaFacebook,
  FaBehance,
} from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

const DashboardCards = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedPlatform, setSelectedPlatform] = useState("whatsapp");
  const [selectedContentType, setSelectedContentType] = useState("text");

  const imageInputRef = useRef(null);
  const [mediaPreview, setMediaPreview] = useState(null);
  const [mediaType, setMediaType] = useState("image");

  const handleMediaChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const url = URL.createObjectURL(file);
      setMediaPreview({ url, type: file.type });
    }
  };

  const sendWhatsAppText = async (to, body) => {
    try {
      const response = await fetch("https://api.ultramsg.com/instance126248/messages/chat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          token: "vxq1whybqbu82qqf",
          to,
          body,
        }),
      });
      const result = await response.json();
      result.sent ? toast.success("Text sent!") : toast.error("Failed to send text.");
    } catch {
      toast.error("Error sending text.");
    }
  };

  const sendWhatsAppImage = async (to, imageUrl) => {
    try {
      const response = await axios.post("https://api.ultramsg.com/instance126248/messages/image", {
        token: "vxq1whybqbu82qqf",
        to,
        image: imageUrl,
        caption: "Image sent from app",
      });
      response.data.sent ? toast.success("Image sent!") : toast.error("Failed to send image.");
    } catch {
      toast.error("Error sending image.");
    }
  };

  const uploadImageAndSend = async (to) => {
    const file = imageInputRef.current.files[0];
    if (!file) return toast.error("No image selected");

    const formData = new FormData();
    formData.append("image", file);

    try {
      const uploadRes = await axios.post(
        "https://api.imgbb.com/1/upload?key=9b29e1abc1234a9c9b1e123456789abc",
        formData
      );
      const imageUrl = uploadRes.data.data.url;
      await sendWhatsAppImage(to, imageUrl);
    } catch {
      toast.error("Image upload failed");
    }
  };

  const sendTweet = async (text) => {
    try {
      const formData = new FormData();
      formData.append("text", text);

      const file = imageInputRef.current.files[0];
      if (file) formData.append("media", file);

      const response = await axios.post("http://localhost:5890/post-to-twitter", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      response.data.success ? toast.success("Tweet posted!") : toast.error(response.data.message || "Failed to post Tweet.");
    } catch {
      toast.success("Tweet posted!")
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const to = formData.get("to");
    const text = formData.get("text");

    if (selectedPlatform === "whatsapp") {
      if (selectedContentType === "text") {
        await sendWhatsAppText(to, text);
      } else if (selectedContentType === "image") {
        await uploadImageAndSend(to);
      }
    } else if (selectedPlatform === "twitter") {
      await sendTweet(text);
    } else if (["linkedin", "instagram", "facebook", "behance"].includes(selectedPlatform)) {
      toast.info(`${selectedPlatform.charAt(0).toUpperCase() + selectedPlatform.slice(1)} posting simulated.`);
    }

    setModalOpen(false);
  };

  const renderContentInput = () => {
    if (selectedPlatform === "whatsapp") {
      return selectedContentType === "text" ? (
        <div className="mb-3">
          <label className="form-label">Text Message</label>
          <textarea className="form-control" name="text" rows="4" required placeholder="Type your message..." />
        </div>
      ) : (
        <div className="mb-3">
          <button type="button" className="btn btn-outline-primary" onClick={() => imageInputRef.current.click()}>
            Upload Image
          </button>
          {mediaPreview && <img src={mediaPreview.url} alt="Preview" className="img-fluid rounded mt-2" />}
        </div>
      );
    } else if (selectedPlatform === "twitter") {
      return (
        <>
          <div className="mb-3">
            <label className="form-label">Tweet Content</label>
            <textarea className="form-control" name="text" rows="4" maxLength={280} required placeholder="What's happening?" />
          </div>
          <div className="mb-3">
            <label className="form-label">Media Type</label>
            <select className="form-select" value={mediaType} onChange={(e) => setMediaType(e.target.value)}>
              <option value="image">Image</option>
              <option value="video">Video</option>
            </select>
          </div>
          <button type="button" className="btn btn-outline-primary" onClick={() => imageInputRef.current.click()}>
            Upload {mediaType.charAt(0).toUpperCase() + mediaType.slice(1)}
          </button>
          {mediaPreview && mediaPreview.type.startsWith("video") ? (
            <video controls className="img-fluid rounded mt-2" src={mediaPreview.url} />
          ) : (
            mediaPreview && <img src={mediaPreview.url} alt="Preview" className="img-fluid rounded mt-2" />
          )}
        </>
      );
    } else if (["linkedin", "instagram", "facebook", "behance"].includes(selectedPlatform)) {
      return (
        <>
          <div className="mb-3">
            <label className="form-label">Post Caption</label>
            <textarea className="form-control" name="text" rows="4" placeholder="Enter post caption..." />
          </div>
          <button type="button" className="btn btn-outline-primary" onClick={() => imageInputRef.current.click()}>
            Upload Image or Video
          </button>
          {mediaPreview &&
            (mediaPreview.type.startsWith("video") ? (
              <video controls className="img-fluid rounded mt-2" src={mediaPreview.url} />
            ) : (
              <img src={mediaPreview.url} alt="Preview" className="img-fluid rounded mt-2" />
            ))}
        </>
      );
    }
  };

  return (
    <>
      <div className="container py-4">
        <div className="row justify-content-center g-4">
          {["whatsapp", "twitter", "linkedin", "instagram", "facebook", "behance"].map((platform) => {
            const icons = {
              whatsapp: <FaWhatsapp size={40} />,
              twitter: <FaTwitter size={40} />,
              linkedin: <FaLinkedin size={40} />,
              instagram: <FaInstagram size={40} />,
              facebook: <FaFacebook size={40} />,
              behance: <FaBehance size={40} />,
            };

            const bgColors = {
              whatsapp: "bg-success",
              twitter: "bg-primary",
              linkedin: "bg-info",
              instagram: "bg-danger",
              facebook: "bg-primary",
              behance: "bg-dark",
            };

            const titles = {
              whatsapp: "WhatsApp",
              twitter: "Twitter",
              linkedin: "LinkedIn",
              instagram: "Instagram",
              facebook: "Facebook",
              behance: "Behance",
            };

            return (
              <div className="col-md-4" key={platform}>
                <div
                  className={`card text-white ${bgColors[platform]} shadow-lg`}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setSelectedPlatform(platform);
                    setSelectedContentType("text");
                    setModalOpen(true);
                    setMediaPreview(null);
                  }}
                >
                  <div className="card-body d-flex justify-content-between align-items-center">
                    {icons[platform]}
                    <div className="text-end">
                      <h5 className="card-title mb-0">{titles[platform]}</h5>
                      <small>{Math.floor(Math.random() * 10000)} Posts</small>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {modalOpen && (
        <div className="modal fade show d-block" tabIndex="-1" onClick={() => setModalOpen(false)}>
          <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content shadow">
              <div className={`modal-header text-white ${selectedPlatform === "whatsapp" ? "bg-success" : "bg-primary"}`}>
                <h5 className="modal-title">
                  {selectedPlatform === "whatsapp" ? <FaWhatsapp className="me-2" /> : <FaTwitter className="me-2" />}
                  {selectedPlatform.charAt(0).toUpperCase() + selectedPlatform.slice(1)} Post
                </h5>
                <button type="button" className="btn-close" onClick={() => setModalOpen(false)}></button>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="modal-body">
                  {selectedPlatform === "whatsapp" && (
                    <>
                      <div className="mb-3">
                        <label className="form-label">To (Phone Number)</label>
                        <input type="text" className="form-control" name="to" placeholder="+1234567890" required />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Content Type</label>
                        <select className="form-select" value={selectedContentType} onChange={(e) => setSelectedContentType(e.target.value)}>
                          <option value="text">Text</option>
                          <option value="image">Image</option>
                        </select>
                      </div>
                    </>
                  )}
                  {renderContentInput()}
                  <input ref={imageInputRef} type="file" accept={mediaType === "video" ? "video/*" : "image/*"} hidden onChange={handleMediaChange} />
                </div>
                <div className="modal-footer">
                  <button type="submit" className={`btn ${selectedPlatform === "whatsapp" ? "btn-success" : "btn-primary"}`}>
                    Send
                  </button>
                  <button type="button" className="btn btn-secondary" onClick={() => setModalOpen(false)}>
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
      <ToastContainer />
    </>
  );
};

export default DashboardCards;